<template>
    <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <NavbarDark/>

        <section class="image-cover faq-sec text-center" :style="{ background: `#eff6ff url(${P}) no-repeat`, backgroundSize: 'cover' }" data-overlay="6">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 position-relative z-1">
                        <h1 class="text-light">{{ $t('Search for an answer to your question') }}</h1>
                        <div class="faq-search">
                            <form>
                                <input name="search" class="form-control" :placeholder="$t('searching input')">
                                <button type="submit"> <i class="fa-solid fa-magnifying-glass"></i> </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="contact-box">
                            <i class="fa-solid fa-basket-shopping text-primary"></i>
                            <h4>{{$t('Contact Sales')}}</h4>
                            <p>info@ruqm-sy.com</p>
                            <span>00963987004477</span>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="contact-box">
                            <i class="fa-solid fa-user-tie text-primary"></i>
                            <h4>{{$t('Contact Sales')}}</h4>
                            <p>info@ruqm-sy.com</p>
                            <span>00963987004477</span>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="contact-box">
                            <i class="fa-solid fa-comments text-primary"></i>
                            <h4>{{$t('Start Live Chat')}}</h4>
                            <span>00963987004477</span>
                            <span class="live-chat">{{$t('Live Chat')}}</span>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-10 col-md-12 col-sm-12">
                        <div class="block-header border-0 m-0">
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <router-link class="nav-link active" id="general-tab" data-bs-toggle="pill" to="#general" role="tab" aria-controls="general" aria-selected="true">{{ $t('General') }}</router-link>
                                </li>
                                
                                <li class="nav-item" role="presentation">
                                    <router-link class="nav-link" id="payment-tab" data-bs-toggle="pill" to="#payment" role="tab" aria-controls="payment" aria-selected="false">{{ $t('Subscription') }}</router-link>
                                </li>
                                
                                <!-- <li class="nav-item" role="presentation">
                                    <router-link class="nav-link" id="upgrade-tab" data-bs-toggle="pill" to="#upgrade" role="tab" aria-controls="upgrade" aria-selected="false">Upgrade</router-link>
                                </li> -->
                            </ul>
                        </div>
                        
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="general" role="tabpanel" aria-labelledby="general-tab">
                                <FaqOne :data="currentFaqData" />
                            </div>
                            
                            <div class="tab-pane fade" id="payment" role="tabpanel" aria-labelledby="payment-tab">
                                <FaqOne :data="currentFaq2Data" />
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import FaqOne from '@/components/faq-one.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import P from '@/assets/img/P.webp';
import { faq2,faqData ,faq2En,faqDataEn} from '@/data/data';
import { computed } from 'vue';
import { useI18n } from "vue-i18n"; 


const { locale } = useI18n();

const currentFaqData = computed(() => {
    return locale.value === 'ar' ? faqData : faqDataEn;
});

const currentFaq2Data = computed(() => {
    return locale.value === 'ar' ? faq2 : faq2En;
});
//SEO
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>
